import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

export function ImportSectionsDialogEmptyState() {
  const { t } = useTranslation();

  return (
    <Stack direction="column" alignItems="center" justifyContent="center" height="100%" gap={1.5} marginTop={6} marginBottom={6}>
      <Typography variant="h6" fontWeight={600} align="center" color="text.secondary">
        {t('library.import_sections_no_sections_message')}
      </Typography>
      <Typography variant="body1" align="center" color="text.secondary">
        {t('library.import_sections_no_sections_message_2')}
      </Typography>
    </Stack>
  );
}
